export default {
  locale: 'fa-ir',
  title: 'فارسی',
  strings: {
    'alerts.noRecord': 'هیچ موردی یافت نشد ',
    'alerts.PasswordsNotMatch':
      'کلمه عبور جدید با تکرار کلمه عبور جدید مطابقت ندارد',
    'errors.title': 'خطا !',
    'errors.canNotAddExsitanceItem':
      'آیتم انتخاب شده موجود است و مجاز به انتخاب مجدد ان نیستید',
    'errors.messageBodyRequired': 'متن پیام اجباری است',
    'errors.messageTitleRequired': 'عنوان پیام اجباری است',
    'errors.fillOutAllFields': 'تمامی فیلد های اجباری را پر کنید',
    'errors.messageDateRequired': 'تاریخ انقضا پیام اجباری است',
    'errors.messageTimeRequired': 'زمان انقضا پیام اجباری است',
    'errors.messageReceiverError': 'گیرنده پیام اجباری است',
    'errors.email': 'فرمت ایمیل معتبر نمی باشد',
    'errors.dateComparison': 'تاریخ پایان نمی تواند از تاریخ شروع عقب تر باشد ',
    'errors.default': 'خطا در ورودی',
    'errors.dateLate': 'تاریخ نمی تواند از امروز بیشتر باشد',
    'errors.name': 'نام باید حداکثر 64 کارکتر و تنها شامل حروف فارسی باشد',
    'errors.address': 'آدرس باید تنها شامل حروف فارسی باشد',
    'errors.description': 'توضیحات باید تنها شامل حروف فارسی باشد',

    'tables.row': 'ردیف',
    'tables.creditFrom': 'اعتبار از',
    'tables.publishStatus': 'وضعیت انتشار',
    'tables.viewStatus': 'وضعیت مشاهده',
    'tables.creditTo': 'اعتبار تا',
    'tables.clientDidNotCome': 'عدم مراجعه',
    'tables.factorPrice': 'مبلغ فاکتور',
    'tables.useability': 'وضعیت استفاده',
    'tables.minSuccessfulReservationValue': 'حداقل مقدار رزرو موفق',
    'tables.reply': 'پاسخ',
    'tables.specialUsers': 'کاربرهای خاص',
    'tables.minOrderInReservation': 'مقدار حداقل سفارش در رزرو',
    'tables.till': 'تا',
    'tables.permittedUsersNeeded': 'استفاده‌کنندگان کدتخفیف',
    'tables.reserve': 'رزرو',
    'tables.includedUsersCount': 'تعداد کاربران مشمول استفاده',
    'tables.startReservation': 'شروع رزرو',
    'tables.respondedAt': 'تاریخ پاسخ',
    'tables.respondedFullName': 'نام کامل پاسخ‌دهنده',
    'tables.reservationTime': 'زمان رزرو',
    'tables.paidPrice': 'هزینه پرداخت‌شده',
    'tables.changeStatus': 'تغییر وضعیت',
    'tables.approveReserve': 'تایید رزرو',
    'tables.rejectReserve': 'رد رزرو',
    'tables.discountPercentage': 'درصد تخفیف',
    'tables.baseCost': 'هزینه پایه',
    'tables.rejectReservation': 'رد رزرو',
    'tables.category': 'دسته‌بندی',
    'tables.notes': 'یادداشت',
    'tables.specifictionDate': 'تاریخ تعیین',
    'tables.count': 'تعداد',
    'tables.checkoutDetails': 'جزییات تسویه',
    'tables.suspended': 'بلاتکلیف',
    'tables.unitPrice': 'قیمت واحد',
    'tables.discountValue': 'مقدار تخفیف',
    'tables.subTotalPrice': 'هزینه فاکتور',
    'tables.usedCount': 'تعداد استفاده‌شده',
    'tables.maxPermittedUsageCount': 'حداکثر تعداد مجاز استفاده',
    'tables.balance': 'بالانس',
    'tables.checkoutType': 'نوع تسویه',
    'tables.totalPrice': 'قیمت کل',
    'tables.minOrder': 'حداقل سفارش',
    'tables.code': 'کد',
    'tables.auditor': 'رسیدگی کننده',
    'tables.requestor': 'درخواست‌دهنده',
    'tables.discount': 'تخفیف',
    'tables.mintotalReservePrice': 'حداقل مجموع سفارش',
    'titles.totalBalance': 'مجموع کل بالانس',
    'titles.finalCheckoutType': 'نوع تسویه نهایی',
    'titles.cafe.reserve.invoice': 'فاکتور رزرو کافه',
    'fields.rsee.totalCafeTables': 'کل میز های کافه',
    'fields.rsee.totalRseeTables': 'میزهای دراختیار آرسی',
    'fields.contractNumber': 'شماره قرارداد',
    'fields.contract.photos': 'تصویر قرارداد',
    'fields.cafe.license': 'پروانه کسب کافه',
    'tables.discountType': 'نوع تخفیف',
    'titles.settelmentManagement': 'مدیریت تسویه حساب‌ها',
    'tables.discountWithCode': 'تخفیف با کد',
    'tables.prePaid': 'پیش پرداخت',
    'tables.payablePrice': 'مبلغ قابل پرداخت',
    'tables.title': 'عنوان',
    'tables.discountCode': 'کدتخفیف',
    'titles.messageReceivers': 'دریافت‌کنندگان پیام',
    'titles.settelmentsList': 'لیست تسویه حساب‌ها',
    'tables.body': 'متن پیام',
    'tables.dayMealPortion': 'وعده‌های غذایی روز',
    'tables.tableNumber': 'شماره میز',
    'titles.best': 'برتر',
    'titles.withEvent': 'با رویداد',
    'titles.withDiscount': 'با تخفیف',
    'tables.mealPortions': 'وعده غذایی',
    'tables.reserveStartingTime': 'ساعت شروع رزرو',
    'tables.reserveEndingTime': 'ساعت پایان رزرو',
    'tables.sumSubTotalprice': 'مجموع مبلغ فاکتور',
    'tables.sumCafeShare': 'مجموع سهم کافه',
    'tables.reservationType': 'نوع رزرو',
    'tables.peopleCount': 'تعداد افراد',
    'tables.totalChairs': 'تعداد صندلی',
    'tables.price': 'قیمت',
    'tables.totalInvoiceItems': 'جمع کل اقلام فاکتور',
    'tables.menuCategoryTitle': 'عنوان دسته‌بندی',
    'tables.publishedAt': 'تاریخ نشر',
    'tables.publisher': 'ناشر',
    'tables.isViewable': 'قابل مشاهده',
    'tables.isPublished': 'منتشر شده',
    'tables.createdAt': 'تاریخ ایجاد',
    'tables.expiredAtJalaali': 'تاریخ انقضا',
    'tables.close': 'تعطیل‌ کردن',
    'tables.lastUpdate': 'آخرین به‌روزرسانی',
    'tables.updatorFullName': 'نام آپدیت کننده',
    'tables.open': 'باز کردن',
    'tables.cafePhoneNumber': 'تلفن کافه',
    'tables.error': 'خطا',
    'tables.editUser': 'ویرایش کاربر',
    'tables.creator': 'ایجاد کننده',
    'tables.bankOtherInfo': 'سایر اطلاعات بانک',
    'tables.toman': 'تومان',
    'tables.cafeManagerName': 'مدیر کافه',
    'tables.submit': 'ثبت',
    'tables.credit': 'اعتبار',
    'tables.paid': 'پرداخت شده',
    'tables.transferring': 'در انتظار پاسخ',
    'tables.deleter': 'نام حذف‌کننده',
    'tables.deletationDate': 'تاریخ حذف',
    'tables.payStatus': 'وضعیت پرداخت',
    'tables.amount': 'مبلغ(تومان)',
    'tables.bankTrackingNumber': 'شماره پیگیری بانک',
    'tables.payTime': 'زمان پرداخت',
    'tables.bankRefrenceNumber': 'شماره مرجع بانک',
    'tables.pending': 'معوق',
    'tables.trackingCode': 'کد رهگیری',
    'tables.trackingCodePayment': 'کد پیگیری پرداخت',
    'tables.trackingCodeReserve': 'کد پیگیری رزرو',
    'tables.activate': 'فعالسازی',
    'tables.displayOrder': 'ترتیب نمایش',
    'tables.asc': 'صعودی',
    'tables.desc': 'نزولی',
    'tables.deactivate': 'غیرفعال کردن',
    'tables.bank': 'بانک',
    'tables.time': 'زمان',
    'tables.bankName': 'نام بانک',
    'tables.date': 'تاریخ',
    'tables.approveReservation': 'تایید رزرو',
    'tables.activated': 'فعال',
    'tables.role': 'نقش',
    'tables.approve': 'تایید',
    'button.acceptWithoutPay': 'تایید بدون هزینه ثبت نام',
    'tables.sortIt': 'مرتب کن',
    'tables.confirmerFullName': 'نام کامل تاییدکننده',
    'tables.message': 'پیام',
    'tables.confimationTime': 'زمان تایید',
    'tables.registrar': 'ثبت کننده',
    'tables.banned': 'محروم',
    'tables.confirmed': 'تایید شده',
    'tables.requested': 'منتظر',
    'tables.roles': 'نقش‌ها',
    'tables.cityName': 'نام شهر',
    'tables.introducer': 'معرف',
    'tables.cafeOwner': 'مالک کافه',
    'tables.fullName': 'نام کامل',
    'tables.status': 'وضعیت',
    'tables.creationDate': 'تاریخ ثبت',
    'tables.type': 'نوع',
    'tables.reviewDate': 'تاریخ بررسی',
    'tables.isSmoking': 'سیگار مجاز',
    'tables.chair': 'صندلی',
    'tables.reviewedBy': 'بررسی شده توسط',
    'tables.reviewerFullName': 'نام کامل بررسی‌کننده',
    'tables.startTime': 'ساعت شروع',
    'tables.endTime': 'ساعت پایان',
    'tables.no': 'شماره میز',
    'tables.financial.transaction.trackingNumber': 'کد رهگیری پرداخت',
    'tables.financial.transaction.type': 'نوع',
    'tables.financial.transaction.amount': 'مبلغ (تومان)',
    'tables.financial.transaction.remainingCredit': 'مانده (تومان)',
    'tables.financial.transaction.createdDate': 'تاریخ',
    'tables.fromHour': 'از ساعت',
    'tables.toHour': 'تا ساعت',
    'tables.financial.transaction.createdTime': 'زمان',
    'tables.financial.transaction.userFullName': 'نام',
    'tables.introducerName': 'نام کاربر ثبت‌نام کننده',
    'tables.percent': 'درصد',
    'tables.showable': 'قابل نمایش',
    'tables.financial.transaction.userMobileNumber': 'موبایل',
    'titles.edit.settings': 'ویرایش تنظیم‌های سیستمی',
    'titles.insertOrEditReservationHour': 'ایجاد یا ویرایش ساعت رزرو',
    'titles.editCafePhotos': 'ویرایش تصویر‌های کافه',
    'titles.userMobileNumber': 'شماره همراه کاربر',
    'titles.redirectedToCafeDiscountRequestArchives':
      'به آرشیو درخواست تخفیف کافه منتقل گردید',
    'titles.cafeDiscountRequestDetails': 'جزییات درخواست تخفیف کافه',
    'titles.editCafeLogo': 'ویرایش لوگو کافه',
    'titles.editLocationTableImage': 'ویرایش تصویر موقعیت مکانی میز ها ',
    'titles.cafeDiscountRequestsList': 'لیست درخواست‌های تخفیف کافه‌ها',
    'titles.cafeDiscountRequestsArchiveList': 'لیست تخفیف کافه‌ها',
    'titles.cafeDiscountRequestsArchive': 'لیست تخفیف کافه‌ها',
    'titles.cafeDiscountRequestsManagement': 'درخواست‌ تخفیف کافه‌ها',
    'titles.editCafeImagesAndLogo': 'ویرایش تصویرها و لوگو کافه',
    'titles.reservationHour': 'ساعت رزرو',
    'titles.reserveStartedAndRedirected':
      'رزرو شروع شد و به منو رزروهای پیش‌رو منتقل گردید',
    'titles.showCafeReserves': 'نمایش رزروهای کافه',
    'titles.reservationRequestsList': 'لیست درخواست‌های رزرو',
    'titles.editDiscountCode': 'ویرایش کدتخفیف',
    'titles.printFactorFooter': 'رزرو آسان و مطمئن با آرسی',
    'titles.cafeLogo': 'لوگو کافه',
    'titles.incomingReservations': 'رزروهای پیش‌رو',
    'titles.schematicReservation': 'شماتیک رزروهای پیش‌رو',
    'titles.incoming.reservations.list': 'لیست رزروهای پیش‌رو',
    'titles.moreDetials': 'جزییات بیشتر',
    'titles.insertOrEditDiscountCode': 'ثبت یا ویرایش کدتخفیف',
    'titles.CafeAdminDashbaordGuide':
      'راهنمای محاسبه‌ها و گزارش‌های پیشخوان مدیر کافه',
    'titles.customerFullName': 'نام کامل مشتری',
    'titles.insertNewCafeEvent': 'ایجاد رویداد جدید',
    'titles.prePayForEachPersonPerHour': 'پیش‌پرداخت رزرو ساعتی هر نفر',
    'titles.IfTheReservationIsRejectedWriteYourReasonHere':
      'در صورت رد رزرو, دلیل خود را اینجا بنویسید',
    'titles.cafe': 'کافه',
    'titles.insertOrEditReservationHourFrom': 'فرم ثبت یا ویرایش ساعت رزرو',
    'titles.averageOrderAmountPerReservationDescription':
      'میانگین مبلغ سفارش هر رزرو= تعداد کُل فاکتورهای همان کافه /مجموع مبلغ فاکتور',
    'titles.averageOrderAmountPerReservation': 'میانگین مبلغ سفارش هر رزرو',
    'titles.averageTotalPeoplePerReservation': 'میانگین تعداد نفرات در هر رزرو',
    'titles.averageTotalPeoplePerReservationDescription':
      'میانگین تعداد نفرات در هر رزرو= تعداد کُل رزروها/مجموع تعداد نفرات رزرو کافه ',
    'titles.insertOrder': 'ثبت سفارش',
    'titles.search': 'جستجو بر اساس:',
    'titles.reservationDayDetails': 'جزییات روز رزرو',
    'titles.repatPassword': 'تکرار کلمه عبور',
    'titles.reservationRequests': 'درخواست‌های رزرو',
    'titles.deleteReservationHour': 'حذف ساعت رزرو',
    'titles.sureToDeleteReservationHour':
      'آیا از حذف این ساعت رزرو اطمینان دارید',
    'titles.reservationHoursList': 'لیست ساعت‌های رزرو',
    'titles.deleteMenuCategory': 'حذف دسته‌بندی منو',
    'titles.reservationHours': 'ساعت‌های رزرو روز',
    'titles.newHour': 'ساعت جدید',
    'titles.menuItemsDeletedsList': 'لیست آیتم‌های حذف‌شده منو',
    'titles.sureToDeleteReservationDay': 'آیا از حذف روز اطمینان دارید',
    'titles.menuCategories': 'دسته‌بندی منوها',
    'titles.cafeImpurityAmount': 'درآمد ناخالص کافه',
    'titles.cafeImpurityAmountDescription':
      'درآمد ناخالص کافه= جمع مبلغ قابل پرداخت کلیه فاکتورهای هر کافه',
    'titles.reservationDate': 'تاریخ رزرو',
    'titles.reservationsManagement': 'مدیریت روزها و ساعت‌ها',
    'titles.menuItemsDeletes': 'حذف‌شده‌های آیتم‌های منو',
    'titles.manage.reserve.days.and.hours': 'مدیریت روزها و ساعت‌های رزرو',
    'titles.reservationDays': 'روزهای رزرو',
    'titles.insertOrEditReservationFrom': 'فرم ثبت یا ویرایش روز رزرو',
    'titles.insertOrEditReservation': 'ثبت یا ویرایش روز',
    'titles.editReserveDay': 'ویرایش روز رزرو',
    'titles.deleteReserveDay': 'حذف روز رزرو',
    'titles.seeReserveHours': 'مشاهده ساعت‌های رزرو',
    'titles.reservationDaysList': 'لیست روزرهای رزرو',
    'titles.menuItems': 'آیتم‌های منو',
    'titles.menuCategoriesDeletedsList': 'لیست دسته‌بندی‌های حذف‌شده منو',
    'titles.newMenuItem': 'آیتم جدید منو',
    'titles.newMenuCategory': 'دسته‌بندی جدید منو',
    'titles.printers': 'پرینترها',
    'titles.editReservationHour': 'ویرایش ساعت‌ رزرو',
    'titles.editRequestedReservation': 'ویرایش درخواست رزرو',
    'titles.editIncomingReservation': 'ویرایش رزرو پیش‌رو',
    'titles.seeAndEditIncomingReserveFactor':
      'مشاهده و ویرایش فاکتور رزرو پیش‌رو',
    'titles.cafeMenuCategories': 'دسته‌بندی منوهای کافه',
    'titles.cafeMenuItems': 'آیتم‌های منوی کافه',
    'titles.additionals': 'اضافات',
    'titles.deductions': 'کسورات',
    'titles.deleteInvoice': 'حذف فاکتور',
    'titles.sureToDelete': 'آیا از حذف فاکتور {fieldName} اطمینان دارید ',
    'titles.sureToDeleteMenuCategory':
      'آیا از حذف دسته‌بندی منو {fieldName} اطمینان دارید ',
    'titles.sureToDeleteMenuItem':
      'آیا از حذف آیتم منو {fieldName} اطمینان دارید ',
    'titles.cafeAdditionals': 'اضافات فاکتور کافه {fieldName}',
    'titles.cafeDeductions': 'کسورات فاکتور کافه {fieldName}',
    'titles.ticketsList': 'لیست تیکت‌ها',
    'titles.cafeInvoces': 'فاکتورهای کافه',
    'titles.previousStep': 'مرحله قبل',
    'titles.cafesCalculations': 'محاسبات کافه‌ها',
    'titles.reserves': 'رزروها',
    'titles.reservesCalculations': 'محاسبات رزروها',
    'titles.rseeDiscountRequestDetails': 'جزییات تخفیف آرسی',
    'titles.reservesCheckout': 'تسویه حساب رزروها',
    'titles.checkoutReport':
      ' تسویه حساب رزروهای پایان یافته و عدم مراجعه',
    'titles.checkoutReportReserves': 'لیست رزروهای مرتبط به کافه ',
    'titles.checkoutReportArchive': 'گزارش تسویه حساب ها',
    'titles.checkedoutReservesList': 'لیست رزروهای برای تسویه',
    'titles.usersCalculations': 'محاسبات کاربرها',
    'titles.checkout': 'تسویه حساب',
    'titles.checkoutAt': 'تاریخ تسویه حساب',
    'titles.checkoutWithCafe': 'تسویه حساب کافه ',
    'titles.yourEnteredPhoneNumber': 'شماره موبایل وارد شده',
    'titles.sendNewMessage': 'ارسال پیام جدید',
    'titles.eventsList': 'لیست رویداد‌ها',
    'titles.eventsManagement': 'مدیریت رویداد‌ها',
    'titles.createNewMessage': 'ایجاد پیام جدید',
    'titles.messageTitle': 'عنوان پیام',
    'titles.addNewEvent': 'ایجاد رویداد جدید',
    'titles.dashboardGuide': 'برای مشاهده راهنما عملکرد پیشخوان',
    'titles.click': 'را کلیک نمایید',
    'titles.here': 'اینجا',
    'titles.ticketDetails': 'جزییات تیکت',
    'titles.backToLogin': 'بازگشت به صفحه ورود',
    'titles.lastName': 'نام‌خانوادگی',
    'titles.forgetMyPassword': 'کلمه عبور خود را فراموش کرده ام',
    'titles.cafeEvents': 'رویداد‌های کافه',
    'titles.nextStep': 'مرحله بعد',
    'titles.disocuntBasicInfo': 'اطلاعات پایه تخفیف',
    'titles.cafeDiscountDetails': 'جزییات تخفیف کافه',
    'titles.cafeDiscount': 'تخفیف کافه',
    'titles.restorePassword': 'بازیابی کلمه عبور',
    'titles.userInfoDetails': 'جزییات اطلاعات کاربر',
    'titles.passwordSuccessfullyChanged': 'کلمه عبور با موفقیت تغییر یافت .',
    'titles.marriageStatus': 'وضعیت تاهل',
    'titles.enterToApplication': 'ورود به اپلیکیشن',
    'titles.enterToPanel': 'ورود به پنل',
    'titles.gender': 'جنسیت',
    'titles.sentAt': 'ایجاد شده در',
    'titles.deleteAddition': 'حذف اضافه',
    'titles.deleteDeduction': 'حذف کسری',
    'titles.userFullName': 'نام و نام‌ خانوادگی کاربر',
    'titles.editSentMessage': 'ویرایش پیام ارسال شده',
    'titles.editMessage': 'ویرایش پیام',
    'titles.FullName': 'نام و نام‌ خانوادگی',
    'titles.messages': 'مدیریت پیام‌ها',
    'titles.marriageDate': 'تاریخ ازدواج',
    'titles.usageDate': 'تاریخ استفاده',
    'titles.insertNewDiscountCode': 'ایجاد کدتخفیف جدید',
    'titles.add.new.cafe': 'ثبت کافه جدید',
    'titles.edit.cafe': 'ویرایش کافه',
    'titles.birthDate': 'تاریخ تولد',
    'titles.submitterInfo': 'مشخصات کاربر ثبت‌کننده',
    'titles.nameOrLastNameOrUsername':
      'نام ، نام خانوادگی  ، نام کاربری و یا شماره موبایل  را وارد کنید',
    'titles.assignNewUserToCafe': 'انتصاب کاربر جدید به کافه',
    'titles.enter': 'ورود',
    'titles.response': 'پاسخ',
    'titles.disableCafeResponse': 'برداشتن مجوز پاسخ',
    'titles.allowCafeToResponse': 'اعطا مجوز پاسخ',
    'titles.responsesPermission': 'پاسخ ها بر اساس مجوز',
    'titles.responses': 'پاسخ ها بر اساس',
    'titles.assignOrEditUser': 'انتصاب یا ویرایش کاربر',
    'titles.cafeUsers': 'مدیریت کاربر‌های کافه',
    'titles.cafeReservationDetails': 'جزییات رزرو',
    'titles.messageDetails': 'جزییات پیام',
    'titles.reserveBasicInfo': 'مشخصات پایه‌ای رزرو',
    'titles.reserve.info': 'مشخصات رزرو',
    'titles.reserve.order': 'ثبت سفارش',
    'titles.reserve.network.printers': 'پرینترهای تحت شبکه',
    'titles.reserve.windows.printers': 'پرینترهای تحت ویندوز',
    'titles.customer.info': 'مشخصات مشتری',
    'titles.messageBasicInfo': 'مشخصات پایه‌ای پیام',
    'titles.messageReceiverInfo': 'مشخصات گیرنده(های) پیام',
    'titles.tablesInfo': 'مشخصات میزها',
    'titles.messageInfo': 'مشخصات پیام',
    'titles.basicInfo': 'مشخصات پایه',
    'titles.systemDescription': 'توضیحات سیستم',
    'titles.paymentInfo': 'مشخصات پرداخت',
    'titles.eghtesadnovin': 'اقتصاد نوین',
    'titles.reservations': 'مدیریت رزروها',
    'titles.selectBankName': 'نام بانک را انتخاب کنید',
    'titles.paymentsManagement': 'پرداخت‌ها از طریق درگاه بانکی',
    'titles.salesReport': 'گزارش میزان فروش',
    'titles.salesReportList': 'لیست گزارش فروش',
    'titles.filter': 'فیلتر',
    'titles.userDetails': 'مشخصات کاربر',
    'titles.paymentDetails': 'جزییات پرداخت',
    'titles.rsee': 'آرسی',
    'titles.userFinancialTransacitons': 'لیست گردش حساب اعتبار کاربر',
    'titles.paymentList': 'لیست پرداخت‌ها از طریق درگاه بانکی',

    'titles.financial.transactions': 'گردش حساب اعتبار مشتری‌ها',
    'titles.financial.transaction.list': 'لیست گردش حساب اعتبار مشتری‌ها',
    'titles.financial.transaction.details': 'جزییات گردش حساب اعتبار مشتری',
    'titles.financial.transaction': 'گردش حساب',

    'titles.settings': 'تنظیم‌های سیستمی',
    'titles.setting.list': 'لیست تنظیم‌های سیستمی',

    'titles.payment': 'پرداخت از طریق درگاه بانکی',
    'titles.logout': 'خروج',
    'titles.cafesManagement': 'مدیریت کافه‌ها',
    'titles.discountsManagement': 'مدیریت کدهای تخفیف‌',
    'titles.profile': 'پروفایل',
    'titles.cafesList': 'لیست کافه‌ها',
    'titles.usersList': 'لیست کاربرها',
    'titles.usersManagement': 'مدیریت کاربرها',
    'titles.totalUsersCount': 'تعداد کل کاربرها',
    'titles.directReserveCostsAverage': 'میانگین هزینه های مستقیم هر رزرو ',
    'titles.totalSuspendedReservations': 'تعداد کل رزروهای بلاتکلیف',
    'titles.directReserveCostsAverageDescription':
      'تعداد کل رزروها / مجموع مبلغ های تخفیف آرسی به ازای رزروها  ',
    'titles.deleteCategory': 'حذف دسته‌بندی',
    'titles.users': 'کاربرها',
    'titles.editCategory': 'ویرایش دسته‌بندی',
    'titles.discountCodeUsersList': 'لیست کاربران استفاده‌کننده',
    'titles.deleteMenuItem': 'حذف آیتم منو',
    'titles.editMenuItem': 'ویرایش آیتم منو',
    'titles.discountsUsers': 'استفاده‌کنندگان کدتخفیف {fieldName}',
    'titles.editUser': 'ویرایش اطلاعات کاربری',
    'titles.deleteCafeUser': 'حذف کاربر کافه',
    'titles.cafeCapacityUsagePercentage':
      'درصد استفاده شده از ظرفیت کافه‌های فعال',
    'titles.cafeCapacityUsagePercentageDescription':
      '100 × (تعداد هفته های فعال هر کافه تا کنون × مجموع تعداد کل ساعت های کاری کافه های فعال در یک هفته × مجموع تعداد صندلی کافه های فعال) / مجموع نفرات رزروها در هر ساعت',
    'titles.contactInformation': 'اطلاعات ارتباطی',
    'titles.reservationInvoices': 'گزارش رزروها',
    'titles.tableInformation': 'اطلاعات میز',
    'titles.services': 'سرویس‌ها',
    'titles.contactType': 'نوع ارتباطی و تماس',
    'titles.first': 'ابتدا',
    'titles.end': 'آخر',
    'titles.caution': 'توجه',
    'titles.hint': 'راهنما',
    'titles.rseeCalculationsHint':
      'تعداد کل فاکتورها / (مجموع مبلغ تخفیف ها – مجموع مبلغ فاکتورها) = میانگین مبلغ فاکتورها',
    'titles.RseeCalculations': 'محاسبات آرسی',
    'titles.workingHoursAndContactInformation': 'ساعت‌های کاری و آیتم‌های تماس',
    'titles.activeUsers': 'درصد کاربر‌های فعال',
    'titles.activeUsersAlert':
      'کاربری فعال است که به طور میانگین حدقل یک بار در ماه، رزرو موفق (پرداخت نهایی) در کافه داشته باشد.',
    'titles.activeUsersDescription':
      '100 × (تعداد کل کاربرهای ثبت شده / تعداد کل کاربرهای فعال) ',
    'titles.RseePureWagesPercentage': 'درصد درآمد خالص آرسی',
    'titles.RseePureWagesPercentageDescription':
      '100 × ((تعداد کل فاکتورها /( مجموع تخفیف های فاکتورها – مجموع مبلغ فاکتور رزروهای موفق) )/ میانگین درآمد خالص از هر رزرو',
    'titles.user': 'کاربر',
    'titles.creatorName': 'نام ایجاد کننده',
    'titles.delete': 'حذف',
    'titles.fromTime': 'از تاریخ',
    'titles.reserveRequestsCount': 'تعداد کل درخواست‌های رزرو',
    'titles.cafesCount': 'تعداد کل کافه‌ها',
    'titles.progressStatistics': 'آمار رویه رشد',
    'titles.clientDoNotCamePercentage': 'درصد عدم مراجعه‌ها',
    'titles.cancelationPercentageFromClient': 'درصد کنسلی از طرف کاربر',
    'titles.cancelationPercentageFromClientDescription':
      '100 × (تعداد کل رزروهای ثبت شده / تعداد کل کنسلی ها) ',
    'titles.activeCafesChairCount': 'تعداد صندلی کافه‌های فعال',
    'titles.cancelationsCount': 'تعداد لغوشده‌ها',
    'titles.clientDoNotCameCount': 'تعداد عدم مراجعه‌ها',
    'titles.userAddedSuccessfully': 'کاربر با موفقیت اضافه شد',
    'titles.activeUsersCount': 'تعداد کاربر‌های فعال',
    'titles.RseeDashbaordGuide':
      'راهنمای محاسبه‌ها و گزارش‌های پیشخوان مدیر آرسی',
    'titles.ChiarsCountAveragePerPerson':
      'میانگین تعداد صندلی‌های استفاده شده به ازای هر نفر',
    'titles.ChiarsCountAveragePerPersonDescription':
      'مجموع تعداد نفرات در کل رزروها / مجموع تعداد کل صندلی های رزرو شده ',
    'titles.averageCostOfOrderPerReserve': 'میانگین مبلغ سفارش هر رزرو',
    'titles.averageCostOfOrderPerReserveDescription':
      'تعداد کل فاکتورها / مجموع مبلغ فاکتور  ',
    'titles.requestedCafesCount': 'تعداد کافه‌های درخواست داده شده',
    'titles.requestedCafesCountDescription':
      'تعداد کل کافه‌هایی که درخواست داده‌اند و در وضعیت انتظار هستند',
    'titles.editionsDoneSuccessfully': 'تغییرات با موفقیت اعمال شد',
    'titles.checkoutDoneSuccessfully': 'تسویه حساب با موفقیت اعمال شد',
    'titles.insertedSuccessfully': 'با موفقیت ثبت شد',
    'titles.deletedSuccessfully': 'با موفقیت حذف گردید',
    'titles.activision': 'فعالسازی',
    'titles.deactivision': 'غیرفعالسازی',
    'titles.pureWagesAveragePerReserve': 'میانگین درآمد خالص از هر رزرو',
    'titles.pureWagesAveragePerReserveDescription':
      '(تعداد کل فاکتورها / (درصد آرسی برای همان رزرو × تخفیف فاکتور رزرو موفق – مبلغ فاکتور هر رزرو موفق)) ',
    'titles.activeCafesCount': 'تعداد کافه‌های فعال',
    'titles.activeCafesDescription':
      'تعداد کل کافه‌هایی که از طرف مدیر سیستم تایید شده‌اند',
    'titles.reservationsCount': 'تعداد کل رزروها',
    'titles.instagramProgressStatistics': 'رویه رشد آماری کاربران اینستاگرام',
    'titles.activatedSuccessfully': 'با موفقیت فعال شد',
    'titles.deactivatedSuccessfully': 'با موفقیت غیرفعال شد',
    'titles.twitterProgressStatistics': 'رویه رشد آماری کاربران تویتر',
    'titles.applicationProgressStatistics': 'رویه رشد آماری کاربران آرسی',
    'titles.telegramProgressStatistics': 'رویه رشد آماری کاربران تلگرام',
    'titles.finalInsert': 'ثبت نهایی',
    'titles.finalInsertAndPrint': 'ثبت نهایی وچاپ',
    'titles.eventBasicInfo': 'اطلاعات پایه رویداد',
    'titles.temporaryInsert': 'ثبت موقت',
    'titles.addToOrder': 'اضافه کردن به سفارش',
    'titles.table': 'میز',
    'titles.reserveMoreInfo': 'اطلاعات بیشتر رزرو',
    'titles.editCafe': 'ویرایش کافه',
    'titles.eventDetails': 'جزییات رویداد',
    'titles.editCafeData': 'جزییات کافه {fieldName}',
    'titles.deletedsAdditions': 'اضافات حذف‌شده',
    'titles.deletedsDeductions': 'کسورات حذف‌شده',
    'titles.deleteMenuCategories': 'دسته‌بندی‌های  حذف‌شده منو',
    'titles.editCafeTimes': 'ویرایش ساعت‌های کاری کافه',
    'titles.deleteUser': 'حذف کاربر',
    'titles.reservesCount': 'تعداد رزروها',
    'titles.totalReserves': 'تعداد دفعات رزرو',
    'titles.userSelectedItems': 'آیتم های ثبت شده کاربر',
    'titles.moreDetails': 'اطلاعات بیشتر',
    'titles.add.new.table': 'درج میز جدید',
    'titles.edit.table': 'ویرایش میز',
    'titles.discountDetails': 'جزییات کدتخفیف',
    'titles.geo.location': 'موقعیت جغرافیایی',
    'titles.event': 'رویداد',
    'titles.discount': 'تخفیف',
    'titles.customerCount': 'تعداد کل مشتری‌ها',
    'titles.add.contact.item': 'درج آیتم تماس جدید',
    'titles.edit.contact.item': 'ویرایش آیتم تماس',
    'titles.contact.item': 'آیتم تماس',
    'titles.details': 'جزییات',
    'titles.seeFactorDetails': 'مشاهده جزییات فاکتور',
    'titles.add.new.working.hour': 'اضافه کردن ساعت کاری جدید',
    'titles.edit.working.hour': 'ویرایش ساعت کاری',
    'titles.userCommentsManagement': 'مدیریت نظرهای کاربرها',
    'titles.userTransactionsList': 'لیست تراکنش‌های کاربر',
    'titles.exchangeUserTickes': 'تبادل تیکت‌های کاربر',
    'titles.sentFactorsToUser': 'فاکتورهای ارسال شده به کاربر',
    'titles.userComments': 'نظرهای ارسالی کاربر',
    'titles.usersComments': 'نظرهای کاربرها',
    'titles.transformedComments': 'تاریخچه نظرهای رد و بدل شده',
    'titles.userReservationsList': 'لیست رزروهای کاربر',
    'titles.dashboard': 'داشبورد مدیریتی',
    'titles.working.hour': 'ساعت کاری',
    'titles.loadMore': 'مشاهده بیشتر',
    'titles.introducerInfo': 'مشخصات معرف',
    'titles.changePassword': 'تغییر کلمه عبور',
    'titles.cafes': 'کافه‌ها',
    'titles.introducedCafes': 'کافه‌های معرفی شده',
    'titles.systemSettings': 'مدیریت تنظیم‌های سیستمی',
    'titles.introducedCafesLit': 'لیست کافه‌های معرفی شده',
    'titles.ticketsManagement': 'مدیریت تیکت‌ها',
    'titles.add.cafe': 'ثبت کافه جدید',
    'titles.cafe.images': 'تصویرهای کافه',
    'titles.reply': 'پاسخ',
    'titles.messagesManagement': 'مدیریت پیام‌ها',
    'titles.enterNewPassword': 'کلمه‌عبور جدید را وارد کنید',
    'titles.setNewPassord': 'ایجاد کلمه‌عبور جدید',
    'titles.reEnterNewPassword': 'تکرار کلمه‌عبور جدید',
    'titles.messagesList': 'لیست پیام‌ها',
    'titles.commentReply': 'پاسخ نظر',
    'titles.contact.items': 'آیتم‌های تماس',
    'titles.changePasswordForm': 'فرم انتخاب کلمه عبور جدید',
    'titles.newPassword': 'کلمه عبور جدید',
    'titles.repeatNewPassword': 'تکرار کلمه عبور جدید',
    'titles.oldPassword': 'کلمه عبور قبلی',
    'titles.newInvoiceAdditions': 'ثبت آیتم جدید به اضافات فاکتور',
    'titles.additions': 'اضافات فاکتور',
    'titles.newInvoiceDeductions': 'کسورات فاکتور جدید',
    'titles.additionsDeleteds': 'فاکتورهای حذف شده اضافات',
    'titles.RseeDiscounts': 'تخفیف‌های آرسی',
    'titles.rejectReasonIsRequired': 'دلیل رد الزامی می‌باشد',
    'titles.checkout.paidAt.IsRequired': 'تاریخ تسویه الزامی می‌باشد',
    'titles.checkout.payerName.IsRequired': 'نام تسویه کننده الزامی می‌باشد',
    'titles.checkout.sourceBankName.IsRequired': 'نام بانک مبدا الزامی می‌باشد',
    'titles.checkout.destinationBankName.IsRequired':
      'نام بانک مقصد الزامی می‌باشد',
    'titles.checkout.payType.IsRequired': 'نحوه تسویه الزامی می‌باشد',
    'fields.checkout.sumBaseCost': 'مجموع پیش پرداختها',
    'fields.checkout.sumRseeStockAmount': 'مجموع سهم آرسی',
    'fields.checkout.minCheckout': 'حد تسویه',
    'fields.checkout.balance': 'مبلغ تسویه',
    'titles.deductionsDeleteds': 'فاکتورهای حذف شده کسورات',
    'titles.my.cafe.info': 'اطلاعات کافه من',
    'titles.show.contract.list': 'نمایش لیست قراردهای کافه ها',
    'titles.manage.contract.list': 'مدیریت قراردادها',
    'titles.contract.list': 'لیست قراردادها',
    'titles.contract': 'قراردادها',
    'titles.add.new.contract': 'ایجاد قرارداد جدید',
    'titles.submit.new.contract': 'ثبت قرارداد جدید',
    'titles.submit.contract': 'ثبت قرارداد',
    'titles.accept.and.submit.contract': 'تایید و ثبت قرارداد',
    'titles.submit.date': 'تاریخ ثبت قرارداد',
    'titles.redirectDiscount':
      'این درخواست تخفیف به لیست آرشیو تخفیف‌ها منتقل گردید',
    'titles.acceptComment': 'تایید',
    'titles.ticketInformation': 'اطلاعات تیکت',
    'titles.archivedCafeEvents': 'لیست رویداد کافه‌ها',
    'titles.editCafeEvent': 'ویرایش رویداد',
    'titles.archivedCafeEventsList': 'لیست آرشیو رویدادهای کافه‌ها',
    'titles.requestedCafeEvents': 'درخواست رویداد کافه‌ها',
    'titles.send': 'ارسال',
    'titles.messagesTransferedInTicket': 'پیام‌های ردوبدل شده در این تیکت',
    'titles.rejectComment': 'رد',
    'titles.sendCodeAgain': 'ارسال مجدد کد',
    'titles.cafeDetails': 'جزییات کافه {fieldName}',
    'titles.edit': 'ویرایش',
    'titles.discountsList': 'لیست کدهای تخفیف‌',
    'titles.percentageHint': 'کدتخفیف بر حسب درصد می‌باشد',
    'titles.nonPercentageHint': 'کدتخفیف بر حسب واحد پولی می‌باشد',
    'titles.rejected': 'رد شده',
    'titles.commentRejectReason': 'دلیل رد کامنت',
    'titles.edit.my.cafe.info': 'ویرایش اطلاعات کافه من',
    'titles.auto.generate.reserve.days.and.hours':
      'تولید خودکار روزها و ساعت‌های رزرو',
    'titles.cafe.discounts': 'تخفیف‌های کافه',
    'titles.manage.my.cafe.discounts': 'مدیریت تخفیف‌های کافه من',
    'titles.manage.my.rsee.discounts': 'مدیریت تخفیف‌های آرسی',
    'titles.my.cafe.discounts.list': 'لیست تخفیف‌های کافه من',
    'titles.my.rsee.discounts.list': 'لیست تخفیف‌های آرسی',
    'titles.add.new.cafe.discount.request': 'ایجاد درخواست تخفیف جدید',
    'titles.manage.ads': 'مدیریت تبلیغ‌ها',
    'titles.ads.list': 'لیست تبلیغ‌ها',
    'titles.add.new.ad': 'ثبت تبلیغ جدید',
    'titles.edit.ad': 'ویرایش تبلیغ',
    'titles.add.new.rsee.discount': 'ایجاد تخفیف آرسی جدید',
    'titles.event.running.times': 'زمان‌های برگزاری رویداد',
    'titles.checkout.final': 'اطلاعات پرداخت',
    'titles.discounts': 'تخفیف‌ها',
    'titles.financial': 'مالی',
    'titles.events': 'رویدادها',
    'titles.base.data': 'اطلاعات پایه',
    'titles.invoice.modal': 'فاکتور {invoiceNo} کافه {cafeName}',
    'titles.reserve.details': 'جزییات رزرو',
    'titles.delete.invoice.addition': 'حذف آیتم از اضافات فاکتور',
    'titles.invoice.additions.list': 'لیست اضافات فاکتور کافه {cafeName}',
    'titles.deleted.invoice.additions.list': 'لیست اضافات حذف شده',
    'titles.reportsOfFinishedReserves':
      'گزارش رزرو های پایان یافته و عدم مراجعه مشتری',

    'menu.dashboard': 'داشبورد',
    'menu.base.data': 'داده‌ها',
    'menu.cafes': 'کافه‌ها',
    'menu.users': 'کاربرها',
    'menu.reserves': 'رزروها',
    'menu.transactions': 'تراکنش‌ها',
    'menu.events': 'رویدادها',
    'menu.reports': 'گزارش ها',
    'menu.tpt': 'تی‌پی‌تی',
    'menu.discounts': 'تخفیف‌ها',

    'modal.user.full.name': 'نام',
    'modal.user.mobile.number': 'شماره موبایل',

    'labels.upstairs': 'طبقه بالا',
    'labels.withPercentage': 'درصدی',
    'labels.chooseSpecialUsers': 'انتخاب کاربرهای خاص',
    'labels.selectDiscountCode': 'کد تخفیف را انتخاب کنید',
    'labels.closeTicket': 'بستن تیکت',
    'labels.selectCafe': 'کافه را انتخاب کنید',
    'labels.discountCodeType': 'نوع کدتخفیف',
    'labels.return': 'بازگشت',
    'labels.chooseDay': 'روز را انتخاب کنید',
    'labels.writeReply': 'پاسخ خود را بنویسید',
    'labels.choosePermittedUsersToUseCode':
      'انتخاب افراد مجاز به استفاده از کدتخفیف',
    'labels.chooseUsers': 'کاربرها را انتخاب کنید',
    'labels.withQuantity': 'مقداری',
    'labels.factorSavedFinally': 'فاکتور به صورت نهایی ذخیره شد .',
    'labels.operator': 'اپراتور',
    'labels.newDiscount': 'ثبت کدتخفیف جدید',
    'labels.factorSavedTemporary': 'فاکتور به صورت موقت ذخیره شد .',
    'labels.newDay': 'روز جدید',
    'labels.auto.generate': 'تولید خودکار',
    'labels.addNewOrder': 'ثبت سفارش جدید',
    'labels.selectItem': 'مورد را انتخاب کنید',
    'labels.userProfile': 'تصویر کاربر',
    'labels.enterCount': 'تعداد را انتخاب کنید',
    'labels.addOrEditUser': 'اضافه کردن یا ویرایش کاربر',
    'labels.manager': 'مدیر',
    'labels.CafeOwner': 'مالک کافه',
    'labels.isPaidRegistrationFee': 'وضعیت پرداخت',
    'labels.sendVerificationCode': 'ارسال کد شناسایی',
    'labels.enterPhoneNumber': 'شماره موبایل خود را وارد کنید',
    'labels.clearForm': 'پاکسازی فرم',
    'labels.new': 'جدید',
    'labels.deleteds': 'حذف شده‌ها',
    'labels.invalidMobileNumber': 'شماره موبایل نامعتبر است',
    'labels.enterRestorationCode': 'کد بازیابی را وارد نماید',
    'labels.mobileNumberFormatInvalid': 'فرمت شماره تماس نادرست است',
    'labels.yes': 'بله',
    'labels.saveAndPublish': 'ذخیره و انتشار',
    'labels.withoutResponse': 'بدون پاسخ',
    'labels.withResponse': 'با پاسخ',
    'labels.no': 'خیر',
    'labels.isCafeOwner': 'آیا مالک کافه می‌باشد',
    'labels.ground.level': 'طبقه همکف',
    'labels.basement': 'زیر زمین',
    'labels.rejectionReason': 'دلیل رد',
    'labels.considerations': 'ملاحظات',
    'labels.outdoor': 'فضای باز',
    'labels.cafeInfo': 'مشخصات کافه',
    'labels.cancel': 'انصراف',
    'labels.delete': 'حذف',
    'labels.editComment': 'ویرایش نظر',
    'labels.do.edit': 'ویرایش کن',
    'labels.do.add': 'اضافه کن',
    'labels.save': 'ذخیره',
    'labels.add.new.working.hour': 'درج ساعت کاری جدید',
    'labels.add.new.contact.item': 'درج آیتم تماس جدید',
    'labels.add.new.table': 'درج میز جدید',
    'labels.activate.cafe': 'فعال‌سازی',
    'labels.disable.cafe': 'غیرفعال‌سازی',
    'labels.financial.transaction.type': 'نوع',
    'labels.financial.transaction.createdFrom': 'از',
    'labels.financial.transaction.createdTo': 'تا',
    'labels.financial.transaction.trackingNumber': 'کد رهگیری',
    'labels.financial.transaction.reserveNumber': 'کد رزرو',
    'labels.financial.transaction.userFullName': 'نام',
    'labels.financial.transaction.userMobileNumber': 'شماره موبایل',
    'labels.according.to.cafe.working.hours': 'طبق ساعت‌های کاری کافه',
    'labels.saturday': 'شنبه',
    'labels.sunday': 'یک‌شنبه',
    'labels.monday': 'دوشنبه',
    'labels.tuesday': 'سه‌شنبه',
    'labels.wednesday': 'چهارشنبه',
    'labels.thursday': 'پنجشنبه',
    'labels.friday': 'جمعه',
    'labels.meals.breakfast': 'صبحانه',
    'labels.meals.lunch': 'ناهار',
    'labels.meals.dinner': 'شام',
    'labels.normal': 'عادی',
    'labels.more.than.five.person': 'بالای ۵ نفر',
    'labels.open.day': 'باز',
    'labels.editUser': 'ویرایش کاربر',
    'labels.addNewUser': 'ثبت کاربر جدید',
    'labels.holiday': 'تعطیل',
    'labels.suspended.day': 'معلق',
    'labels.createRandomCode': 'ایجاد کد تصادفی',
    'labels.percent': 'درصد',
    'labels.amount.in.toman': 'مبلغ (تومان)',
    'labels.weekday': 'روز هفته',
    'labels.row': 'ردیف',
    'labels.from.date': 'از تاریخ',
    'labels.to.date': 'تا تاریخ',
    'labels.reservesCount': 'تعداد رزروها',
    'labels.status': 'وضعیت',
    'labels.request.date.time': 'زمان درخواست',
    'labesl.with.suspended': 'با بلاتکلیف',
    'labesl.without.suspended': 'بدون بلاتکلیف',
    'labels.both': 'هر دو',
    'labesl.with.event': 'با رویداد',
    'labesl.without.event': 'بدون رویداد',
    'labesl.with.discount': 'با تخفیف',
    'labesl.without.discount': 'بدون تخفیف',
    'labesl.in.bests': 'برتر',
    'labesl.not.in.bests': 'غیربرتر',
    'labels.score': 'امتیاز',
    'labels.ad.image': 'تصویر',
    'labels.display.order': 'ترتیب نمایش',
    'labels.display.status': 'وضعیت نمایش',
    'labels.make.visible': 'فعال‌سازی',
    'labels.make.invisible': 'غیرفعال‌سازی',
    'labels.visible': 'فعال',
    'labels.invisible': 'غیرفعال',
    'labels.count.unit': 'عدد',
    'labels.person.unit': 'نفر',
    'labels.excel.output': 'خروجی اکسل',
    'labels.waiting': 'در انتظار',
    'labels.last.reviewed.at': 'زمان آخرین بازبینی',
    'labels.close.modal': 'انصراف',
    'labels.customer': 'مشتری',
    'labels.reserve.individuals.count': 'تعداد نفرات',
    'labels.tables.num': 'شماره میزها',
    'labels.meals': 'وعده غذایی',
    'labels.reserve.date': 'تاریخ رزرو',
    'labels.reserve.hour': 'ساعت رزرو',
    'labels.hour': 'ساعت ',
    'labels.reserve.status': 'وضعیت رزرو',
    'labels.invoice.status': 'وضعیت فاکتور',
    'labels.order.items': 'آیتم‌های سفارش',
    'labels.preOrder.items': 'آیتم‌های پیش سفارش',
    'labels.sub.total.price': 'جمع کل',
    'labels.pre.paid.amount': 'پرداخت آنلاین',
    'labels.total.price': 'مبلغ کل فاکتور',
    'labels.to.be.paid.to.cafe.price': 'قابل پرداخت',
    'labels.discount.code.amount': 'کد تخفیف',
    'labels.hourly.discount.amount': 'تخفیف ساعتی',
    'labels.percent.value': '{percent} درصد',
    'labels.additions.amount': 'اضافات',
    'labels.rsee.stock.amount': 'سهم آرسی',
    'labels.rsee.stock.type': 'نوع سهم آرسی',
    'labels.balance.amount': 'بالانس',
    'labels.unit.price': 'قیمت واحد',
    'labels.item.cost': 'مبلغ',
    'labels.qty': 'تعداد',
    'labels.item': 'نام آیتم',
    'labels.pre.order': 'سفارش تقریبی',
    'labels.temp.save': 'ثبت موقت',
    'labels.invoice.billing': 'ثبت نهایی',
    'labels.invoice.billing.try.again': 'چاپ فاکتور',
    'labels.receipt.issued': 'صدور فیش',
    'labels.factor.issued': 'صدور فاکتور',
    'labels.show.on.customer.invoice': 'نمایش در فاکتور مشتری',
    'labels.receiver': 'گیرنده پیام',
    'labels.receiverType': 'نوع گیرنده پیام',
    'labels.selectReceivers': 'گیرنده‌های پیام',
    'labels.defaultAd': ' تبلیغ پیش فرض',
    'labels.undefaultAd': 'حذف تبلیغ پیش فرض',
    'labels.back': 'بازگشت',
    'labels.delete.addition.item': 'حذف آیتم',
    'labels.toman': 'تومان',
    'labels.checkout': 'تسویه حساب',
    'labels.relatedReservation': 'رزروهای مرتبط',

    'pagination.first': 'ابتدا',
    'pagination.last': 'آخر',
    'pagination.previous': 'قبلی',
    'pagination.next': 'بعدی',

    'messages.loginFailed': 'ورود موفقیت آمیز نبود',
    'messages.select.an.item': 'یک مورد را انتخاب کنید',
    'messages.server.error':
      'در این لحظه خطایی رخ داده لطفا مجددا امتحان کنید و یا با مدیر آرسی در تماس باشید.',
    'messages.addCafe': 'ثبت کافه',
    'messages.discountPercentageCannoutBeMoreThan100':
      'درصد تخفیف نمی‌تواند بیشتر از 100 باشد',
    'messages.fieldValueIsRequired': '{fieldName} اجباری است',
    'messages.fieldValueIsInvalid': '{fieldName} {fieldValue} معتبر نیست',
    'messages.myCafe': 'کافه من',
    'messages.basicInfo': 'اطلاعات پایه',
    'messages.appPasswordSet': 'کلمه عبور اپلیکیشن تنظیم شده است',
    'messages.reset': 'تنظیم مجدد',
    'messages.uploadLogo': 'لوگو خود را بارگذاری کنید',
    'messages.uploadMenu': 'منو خود را بارگذاری کنید',
    'messages.description': 'توضیحات',
    'messages.selectMealPortions': 'وعده‌های غذایی را انتخاب کنید',
    'messages.noDescription': 'توضیحاتی ثبت نشده است',
    'messages.day': 'روز',
    'messages.previous': 'قبلی',
    'messages.sortBy': 'مرتب سازی بر اساس',
    'messages.next': 'بعدی',
    'messages.yes': 'بله',
    'messages.no': 'خیر',
    'messages.userDeleteAlert': 'آیا از حذف {fullName} کاربر اطمینان دارید ؟',
    'messages.submitChanges': 'ثبت تغییرات',
    'messages.password': 'کلمه عبور',
    'messages.cafeName': 'نام کافه',
    'messages.username': 'نام کاربری',
    'messages.indoor': 'داخل سالن',
    'messages.isSetBefore': 'تنظیم شده است',
    'messages.facilities': 'امکانات',
    'messages.outdoor': 'فضای باز',
    'messages.isSmokingAllowed': 'سیگار مجاز است ؟',
    'messages.haveHeatSystem': 'سیستم گرمایشی دارد ؟',
    'messages.has.cooling.system': 'سیستم سرمایشی دارد؟',
    'messages.has.fog.spray': 'سیستم مه پاش دارد؟',
    'table.title': 'لقب میز',
    entrance: 'ورودی',
    inputAmount: ' مبلغ ورودی',
    'messages.numberOfChairs': 'تعداد صندلی‌ها',
    'messages.selectServices': 'انتخاب سرویس‌ها',
    'messages.specialServices': 'سرویس های ویژه',
    'messages.tables': 'میزها',
    'messages.rseeTables': 'میزهای آرسی',
    'messages.address': 'آدرس',

    'messages.cafeInstagram': 'آدرس اینستاگرام',
    'messages.cafeTableNumber': 'تعداد میز های کافه',
    'messages.registrationFee': 'هزینه ثبت نام',
    'messages.hasRegistrationFee': 'هزینه ثبت نام دارد',

    'messages.cityName': 'نام شهر',
    'messages.regions': 'مناطق',
    'messages.unit': 'واحد',
    'messages.email': 'ایمیل',
    'messages.selectRegion': 'انتخاب منطقه',
    'messages.selectCities': 'انتخاب شهر',
    'messages.select.regions': 'منطقه‌های جغرافیایی کافه را انتخاب کنید',
    'messages.select.cities': ' شهر کافه را انتخاب کنید',
    'messages.select.amenities': 'امکانات کافه را انتخاب کنید',
    'messages.select.printers': 'پرینترها را انتخاب کنید',
    'messages.workingHours': 'ساعتهای کاری',
    'messages.selectDay': 'انتخاب روز',
    'messages.add': 'اضافه کن',
    'messages.contactType': 'نوع ارتباطی',
    'messages.selectContactWay': 'انتخاب مسیر ارتباطی',
    'messages.quantity': 'مقدار',
    'messages.name': 'نام',
    'messages.selectAmenities': 'انتخاب امکانات',
    'messages.fieldValueIsDuplicate': '{fieldName} تکراری است',
    'messages.fieldValueHasNotCorrectFormat': 'فرمت {fieldName} نادرست است',
    'messages.selectOneRegionsIsMandatory': 'انتخاب حداقل یک منطقه اجباری است',
    'messages.selectCitiesIsMandatory': 'انتخاب شهر اجباری است',
    'messages.selectOneWeekdayIsMandatory':
      'انتخاب حداقل یک روز هفته اجباری است',
    'messages.selectOneItemIsMandatory':
      'انتخاب حداقل یک {itemName} اجباری است',
    'messages.selectCafeShopLocationIsMandatory':
      'مشخص کردن مکان کافی‌شاپ روی نقشه اجباری است',
    'messages.delete.confirm': 'آیا از حذف {itemTitle} اطمینان دارید؟',
    'messages.sample.cafe.address':
      'به عنوان نمونه: بلوار کریم‌خان زند، خیابان رودکی، کوچه ۲ رودکی، ابن سینا',
    'messages.sample.cafe.name': 'به عنوان نمونه:‌ کافه/رستوران عتیق',
    'messages.sample.bank.name': 'به عنوان نمونه:‌ ملت',
    'messages.sample.card.number': 'شماره کارت را وارد کنید',
    'messages.sample.account.number': 'شماره حساب را وارد کنید',
    'messages.sample.cafe.owner.full.name': 'به عنوان نمونه: پژمان پارسایی',
    'messages.rsee.percent.help.text': 'درصد سهم آرسی از فاکتور هر رزرو',
    'messages.rsee.minCheckout.help.text': 'حد تسویه حساب',
    'messages.hint.select.cafe.geo.location.on.map':
      'راهنما: با کلیک روی یک نقطه از نقشه، مکان جغرافیایی کافه را مشخص نمایید',
    'messages.edit.success': 'تغییرات با موفقیت ذخیره شد.',
    'messages.introducerName': 'نام معرف',
    'messages.fieldNameIsMandatory': '{fieldName} اجباری است',
    'messages.selectValueForFieldIsMandatory': 'انتخاب {fieldName} اجباری است',
    'messages.violateMaxValue': 'حداکثر مقدار {fieldName} {maxValue} است',
    'messages.fieldValueNoNumber': '{fieldValue} عدد نادرستی است',
    'messages.select.cafe.tables': 'میزهای کافه را انتخاب کنید',
    'messages.breakfastFromTimeMustBeLessThanItsToTime':
      'زمان شروع صبحانه باید کمتر از زمان پایان آن باشد',
    'messages.lunchFromTimeMustBeLessThanItsToTime':
      'زمان شروع ناهار باید کمتر از زمان پایان آن باشد',
    'messages.dinnerFromTimeMustBeLessThanItsToTime':
      'زمان شروع شام باید کمتر از زمان پایان آن باشد',
    'messages.a.new.reserve.request.was.submitted':
      'یک درخواست رزرو جدید به کد رهگیری {trackingNumber} ثبت شد',
    'messages.some.reserves.automatically.approved':
      'تعداد {reservesCount} رزرو به صورت خودکار تایید شد',
    'messages.reserve.was.cancelled.by.user':
      'رزرو تاریخ {date} توسط مشتری {client} کنسل شد',
    'messages.copyright.text':
      'تمام حقوق مادی و معنوی این وب‌اپلیکیشن متعلق به آرسی می‌باشد © {year}',
    'messages.input.display.order.helper.text':
      'در صورت تمایل می‌توانید یک عدد صحیح از 0 تا 32767 وارد کنید',
    'messages.input.delay.time.helper.text':
      'یک عدد صحیح از 1 تا 10 که نشانگر زمان به ثانیه است وارد کنید',
    'messages.input.ad.link.url.helper.text':
      'به عنوان نمونه: http://www.rsee.ir/about-us.html',
    'messages.select.ad.image.helper.text': 'یک تصویر با پسوند jpg  یا از لیست پیشنهادی روبرو انتخاب کنید',
    'messages.enter.at.least.one.event.time.is.mandatory':
      'وارد کردن حداقل یک زمان برگزاری رویداد اجباری است',
    'messages.you.have.unread.notifications': 'شما اعلان‌ خوانده نشده دارید',
    'messages.select.cafe': 'یک کافه را از لیست انتخاب کنید',
    'messages.selecting.cafe.is.mandatory': 'کافه را انتخاب کنید',
    'messages.error.in.api.operation': 'خطا در ارتباط',
    'messages.specify.suspended.reserve':
      'زمان رزرو گذشته است، تکلیف آن را مشخص نمایید',
    'messages.reply.text.help.text':
      'حداکثر 512 کاراکتر برای متن پاسخ مجاز است',
    'messages.sample.amount': 'به عنوان نمونه: ۱۲۵۰۰',
    'messages.sample.amount.percent': 'به عنوان نمونه: ۹',
    'messages.input.amount.as.toman': 'مبلغ را به *تومان* وارد نمایید',
    'messages.input.amount.as.percent':
      'مبلغ را به بصورت عدد که نشان‌دهنده درصد است وارد کنید',
    'messages.sample.invoice.addition.title': 'به عنوان نمونه: هزینه سرویس',
    'messages.error.input.valid.percent': 'درصد باید یک عدد کمتر از ۱۰۰ باشد',
    'messages.delete.invoice.addition.confirm':
      'آیا از حذف {fieldName} از اضافات فاکتور کافه خود اطمینان دارید؟',
    'messages.reserve.request.was.rejected': 'درخواست رزرو مورد نظر رد شد',
    'messages.reserve.request.was.started': 'رزرو با موفقیت شروع شد.',
    'messages.you.can.save.customer.invoice':
      'می‌توانید سفارش‌های مشتری را در فاکتور رزرو وی ثبت کنید',
    'messages.reserve.request.was.approved': 'درخواست رزرو با موفقیت تایید شد',
    'messages.confirm.reserve.info.was.send.to.customer':
      'به مشتری اطلاعات لازم برای حضور در کافه داده شد',
    'messages.client.do.not.came.after.reserve.started':
      'وضعیت رزرو به مشتری نیامد ثبت شد',
    'messages.share.of.pre.paid.amount.are.paid.to.cafe':
      'مبلغ معینی از پیش‌پرداخت به کافه پرداخت می‌شود',

    'fields.cafe.checkoutAtPlaceholder':
      'تاریخ تسویه حساب در فرمت روز/ماه/سال: ۱۳۷۲/۰۷/۱۷',
    'fields.cafe.checkoutAt': 'تاریخ تسویه حساب',
    'fields.cafe.name': 'نام کافه',
    'fields.bank.name': 'نام بانک',
    'fields.card.number': 'شماره کارت',
    'fields.check.number': 'شماره چک',
    'fields.account.number': 'شماره حساب',
    'fields.cafe': 'کافه',
    'fields.selectDate': 'انتخاب تاریخ',
    'fields.cafe.status': 'وضعیت کافه',
    'fields.fromTime': 'زمان شروع',
    'fields.toTime': 'زمان پایان',
    'fields.duration': 'مدت',
    'fields.address': 'آدرس',
    'fields.startPublishedAtDate': 'تاریخ شروع نشر',
    'fields.endPublishedAtDate': 'تاریخ پایان نشر',
    'fields.startCreatedAtDate': 'تاریخ شروع ایجاد',
    'fields.endCreatedAtDate': 'تاریخ پایان ایجاد',
    'fields.cafe.shop.geo.locaion': 'مکان کافی‌شاپ روی نقشه',
    'fields.nationalCode': 'کد ملی',
    'fields.reset': 'حذف فیلتر‌ها',
    'fields.mobileNumber': 'شماره موبایل',
    'fields.verificationCode': 'کد تایید',
    'fields.startDate': 'تاریخ شروع',
    'fields.endDate': 'تاریخ پایان',
    'fields.applyFilters': 'اعمال فیلتر‌ها',
    'fields.email': 'ایمیل',
    'fields.table.no': 'میز شماره',
    'fields.table.numberOfChairs': 'تعداد صندلی',
    'fields.table': 'میز',
    'fields.floor': 'طبقه',
    'fields.heatSystem': 'سیستم گرمایشی',
    'fields.coolingSystem': 'سیستم سرمایشی',
    'fields.fogCoolingSystem': 'سیستم مه پاش',
    'fields.area': 'محوطه',
    'fields.regions': 'منطقه‌های جغرافیایی',
    'fields.contact.type': 'نوع',
    'fields.contact.value': 'مقدار',
    'fields.week.day': 'روز هفته',
    'fields.discounts': 'تخفیف‌ها',
    'fields.start.time': 'زمان شروع',
    'fields.requestTime': 'زمان درخواست',
    'fields.end.time': 'زمان پایان',
    'fields.cafe.logo.image': 'تصویر لوگوی کافه',
    'fields.cafe.menu.image': 'تصویر منوی کافه',
    'fields.table.location.image': 'تصویر موقعیت مکانی میز ها',
    'fields.row': 'ردیف',
    'fields.description': 'توضیحات',
    'fields.financial.transaction.type': 'نوع گردش حساب',
    'fields.createdAt': 'زمان ثبت',
    'fields.remainingCredit': 'اعتبار فعلی',
    'fields.amount': 'مبلغ',
    'fields.priorCredit': 'اعتبار قبلی',
    'fields.payment.amount': 'مبلغ پرداختی',
    'fields.bankPortalName': 'بانک',
    'fields.trackingNumber': 'کد پیگیری',
    'fields.reserveCode': 'کد پیگیری رزرو',
    'fields.bankReferenceNumber': 'کد مرجع بانک',
    'fields.bankTracingNumber': 'کد پیگیری بانک',
    'fields.paidAt': 'زمان پرداخت',
    'fields.payment.createdAt': 'زمان درخواست',
    'fields.payment.status': 'وضعیت پرداخت',
    'fields.cafe.owner.full.name': 'مدیر کافه',
    'fields.cafe.contract.date': 'تاریخ ثبت قرارداد',
    'fields.reserve.start.date': 'زمان شروع رزرو',
    'fields.reserve.end.date': 'زمان پایان رزرو',
    'fields.cafe.contract.start.date': 'تاریخ شروع قرارداد',
    'fields.cafe.contract.end.date': 'تاریخ پایان قرارداد',
    'fields.cafe.contract.end.date.14.days.ago':
      ' پایان قرارداد در 14 روز آینده',
    'fields.cafe.minCheckout': 'حد تسویه کافه',
    'fields.rsee.percent': 'درصد سهم آرسی',
    'fields.rsee.amount': 'مبلغ سهم آرسی',
    'fileds.userImage': 'تصویر کاربر',
    'fields.from.date': 'از تاریخ',
    'fields.to.date': 'تا تاریخ',
    'fields.weed.days': 'روزهای هفته',
    'fields.hours': 'ساعت‌ها',
    'fields.tables': 'میزها',
    'fields.day.meals': 'وعده‌های غذایی روز',
    'fields.day.meals.hour': 'ساعت وعده‌های غذایی روز',
    'fields.from': 'از',
    'fields.to': 'تا',
    'fields.reserve.type': 'نوع رزرو',
    'fields.status': 'وضعیت',
    'fields.has.discount': 'دارای تخفیف',
    'fields.ad.image': 'تصویر تبلیغ',
    'fields.display.order': 'ترتیب نمایش',
    'fields.ad.delay.time': 'زمان توقف',
    'fields.ad.link.url': 'لینک به آدرس',
    'fields.expiredAtJalaali': 'تاریخ انقضا',
    'fields.checkout.paidAt': 'تاریخ تسویه',
    'fields.checkout.sourceBankName': 'نام بانک مبدا',
    'fields.checkout.destinationBankName': 'نام بانک مقصد',
    'fields.checkout.payerName': 'نام تسویه کننده',
    'fields.checkout.cardNumber': 'شماره کارت وارد شده در قراردادها',
    'fields.checkout.payType': 'نحوه تسویه',
    'fields.checkout.payTypeValue': 'شماره چک',
    'fields.comment.sender.name': 'نام ارسال‌کننده نظر',
    'fields.name': 'نام',
    'fields.reply.text': 'متن پاسخ',
    'fields.percent': 'درصد',

    'placeholders.financial.transaction.type': 'نوع گردش حساب را انتخاب کنید',
    'placeholders.financial.transaction.createdFrom': 'تاریخ را انتخاب کنید',
    'placeholders.selectStatus': 'وضعیت را انتخاب کنید',
    'placeholders.financial.transaction.createdTo': 'تاریخ را انتخاب کنید',
    'placeholders.financial.transaction.trackingNumber':
      'یک یا چند شماره از کد رهگیری را وارد کنید',
    'placeholders.financial.transaction.mobile.number':
      'یک یا چند شماره وارد کنید',
    'placeholders.financial.transaction.full.name': 'یک یا چند کلمه وارد کنید',

    'maxLength.100': 'حداکثر طول کاراکتر مجاز ۱۰۰ حرف می باشد',
    'maxLength.50': 'حداکثر طول کاراکتر مجاز ۵۰ حرف می باشد',
    'maxLength.30': 'حداکثر طول کاراکتر مجاز ۳۰ حرف می باشد',
    'maxLength.20': 'حداکثر طول کاراکتر مجاز ۲۰ حرف می باشد',
    'maxLength.15': 'حداکثر طول کاراکتر مجاز ۱۵ حرف می باشد',
    'maxLength.16': 'حداکثر طول کاراکتر مجاز ۱۶ حرف می باشد',
    clientDoNotComeReason: 'دلیل عدم مراجعه',
    date: 'تاریخ',
    'total.rsee.tables.percent': 'درصد میزهای در اختیار آرسی',

    setting: 'تنظیمات ',
    'description.printers': 'تعریف پرینترها',
    printer: ' پرینتر',
    'printers.details': 'جزییات پرینتر',
    'table.edit': 'عملیات',
    //Note : spell correction
    'label.cancel': 'انصراف',
    'printers.list': 'لیست پرینترها',
    'edit-printer': 'ویرایش پرینتر',
    'message.input.amount.is.necessary': 'لطفا مبلغ ورودی را وارد کنید.',
    'file.uploaded': ' آپلودشد',
    factor: ' فاکتور  ',
    'cafe.factor': ' فاکتور کافه ',
    'factor.number': ' فاکتور شماره   ',
    'label.number': '  شماره   ',
    'label.reserve.number': '  شماره رزرو',
    'reservation.date': ' تاریخ رزرو',
    'label.table.no': 'میز شماره ',
    'online-paid': 'پرداخت آنلاین',
    'all.amounts.are.in.Tomans': '** کلیه مبالغ به تومان می باشد',
    'factor.footer.message': 'رزرو آسان و مطمئن با آرسی',
    'insert.new.reservation.timing': 'تولید روزها و ساعت های رزرو',
    'new.reservation.timing': 'زمان بندی رزرو جدید',
    'title.create.new.timing': 'ایجاد زمان بندی جدید',
    'title.edit.timing': 'ویرایش زمان بندی',
    'reservation.timetable': 'لیست زمان بندی ها',
    'title.save.edit.timing.after.seven.days':
      'در صورت ایجاد تغییرات،  پس از هفت روز اعمال می شوند.',
    'title.default.cafe.tables': 'تمام میزهای فعال کافه در نظر گرفته می شوند.',
    'titles.successfully': 'با موفقیت انجام شد.',
    'label.current.status': 'وضعیت فعلی',
    'label.first.rejection': 'رد اولیه',
    'label.final.rejection': 'رد نهایی',
    'label.registered': 'ثبت سیستمی',
    'label.registered.WithoutPay': 'ثبت سیستمی بدون هزینه ثبت نام',
    'tables.totalBox': 'مجموع صندوق',
    'tables.totalBalanceAmount': 'مجموع طلب از آرسی',
    'tables.TotalPriceFactor': 'مجموع کل فاکتور',
    'tables.sumCheckoutWithCafesBalances': 'مجموع مبلغ تسویه شده',
    'tables.rseeBalanceRemains': 'باقی مانده طلب از آرسی',
    'table.status':'وضعیت میز',
    'this.table.is.being.booked.by.the.customer':'این میز توسط مشتری در حال رزرو شدن است.',
    'titles.cafe.info': 'اطلاعات کافه',
    'titles.contract.info': 'اطلاعات قرارداد',
    'warning.you.changed.the.rsee.stock.type.please.enter.rsee.amount.too': 'توجه: شما نوع سهم آرسی را تغییر داده اید. لطفا پس از ثبت تغییرات ، به صفحه ی جزییات کافه مراجعه کرده و "مبلغ سهم آرسی" را وارد کنید.',
    'warning.you.changed.the.rsee.stock.type.please.enter.rsee.percent.too': 'توجه: شما نوع سهم آرسی را تغییر داده اید. لطفا پس از ثبت تغییرات ، به صفحه ی جزییات کافه مراجعه کرده و "درصد سهم آرسی" را وارد کنید.',
    'title.cafes.amenities':'امکانات کافه',
    'title.financial.informations':'اطلاعات مالی',
    'fields.rsee.stock.amount': 'مبلغ سهم آرسی',
    'messages.rsee.stock.amount.help.text': 'مبلغ دریافتی ثابت بابت هر رزرو',
    'cafes.type':'نوع کافه',
    'takeaway':'تیک اوی',
    'messages.select.cafes.type': 'نوع کافه را انتخاب کنید',
    'titles.show.takeaway.cafes.financial.report': 'گزارش مالی کافه های takeaway',
    'title.financial.report': 'گزارش مالی',
    'three.month.charge.amount': 'مبلغ شارژ سه ماهه',
    'pay': 'پرداخت',
    'packages': 'بسته ها',
    'packages.management': 'مدیریت بسته ها',
    'add.new.package': 'ایجاد بسته جدید',
    'edit.package': 'ویرایش بسته',
    'package.name': 'نام بسته',
    'package.price': 'قیمت بسته',
    'package.create.date': 'تاریخ ایجاد بسته',
    'package.status':'وضعیت بسته',
    'gift.chairs': 'صندلی هدیه',
    'add.gift.chairs': 'ایجاد صندلی هدیه',
    'packages.list': 'لیست بسته ها',
    'packages.report': 'گزارش بسته ها',
    'reserves.report.with.constant.amount': 'گزارش رزروها با مبلغ ثابت',
    'reserves.report.with.package': 'گزارش رزروها با بسته',
    'chairs.charging.report': 'گزارش شارژ صندلی',
    'rsee.charging.report': 'گزارش شارژ آرسی',
    'buy.package.report': 'گزارش خرید بسته ها',
    'enter.certain.user.phone.number':'شماره تماس کاربر مورد نظر',
    'menu.item.image': 'تصویر آیتم منو',
    'the.duration.of.each.reservation': 'مدت زمان هر رزرو',
    'phone.number': 'شماره تماس',
    'manage.cities.and.regions': 'مدیریت شهرها و مناطق جغرافیایی',
    'city.code': 'کد شهر',
    'add.new.city': 'اضافه کردن شهر جدید',
    'edit.city': 'ویرایش شهر',
    'example.shiraz': 'مثلا: شیراز',
    'cities.list': 'لیست شهرها',
    'region.name': 'نام منطقه جغرافیایی',
    'edit.region': 'ویرایش منطقه',
    'see.regions.list': 'لیست مناطق جغرافیایی',
    'add.new.region': 'اضافه کردن منطقه جدید',
    'regions.list': 'لیست مناطق',
    'added.regions.list': 'لیست مناطق اضافه شده',
    'close.modal': 'بستن مودال',
    'total.online.paid': 'جمع پرداختی آنلاین',
    'prePaid.amount': 'مبلغ پیش پرداخت',
    'entrance.amount': 'مبلغ ورودی',
    'rsee.discount.code': 'تخفیف آرسی',
    'sum.total.paid.price.to.buy.package': 'مبلغ کل پرداخت شده بابت خرید بسته',
    'sum.total.bought.rsee': 'تعداد کل آرسی های خریداری شده',
    'title.reservation.fee': 'هزینه ی رزرو',
    'title.has.no.reservation.fee': 'این کافه هزینه ی رزرو ندارد',
    'registration.fee.toman': 'هزینه ی ثبت نام (تومان)',
    'contract.duration.month': 'مدت قرارداد اولیه (ماه)',
    'six.month.subscription.fee.toman': 'مبلغ اشتراک 6 ماهه (تومان)',
    'twelve.month.subscription.fee.toman': 'مبلغ اشتراک 12 ماهه (تومان)',
    'cafe.city.info': 'مشخصات شهر کافه',
    '': '',
    '': '',
    '': '',
    '': '',
    '': '',
  },
};
